window.addEventListener("load", function() {
  document.querySelectorAll('.fulliframe').forEach(function(this_click){
  this_click.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  });
});

function mediaslider(){
  var mediaslider=[];
  document.querySelectorAll('.hero-media-slider').forEach(function(Element,index){
    var mediaid = Element.dataset.id;
    var media_autoplay = Element.dataset.autoplay;
    let swiperObject={
      loop:false,
      // simulateTouch: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
    };
    if(eval(media_autoplay)==true){
      swiperObject.autoplay={
        delay: eval(Element.dataset.playtime)
      }
    }
    mediaslider[mediaid]=new Swiper(Element,swiperObject );
  });
}
mediaslider();



   